const config = {
    position: 'bottom-right',
    newestOnTop: true,
    draggablePercent: 50,
};

export default config;
